import styled, { css } from 'styled-components'
import {
    svgStroke,
    belowDesktop, belowTablet, belowPhone, fromDesktop, fromPhone
} from 'utilities/styled'
import {
    Grid,
    GridColumnHeader as GridColumnHeaderBase,
    GridColumnHeaderSortable as GridColumnHeaderSortableBase
} from 'components/grid'
import { SkeletonListRow as SkeletonListRowBase, SkeletonCell as SkeletonCellBase } from 'components/skeleton'
import TutorialBase from 'components/tutorial'
import EmptyBase from 'components/empty'

export const Wrap = styled(Grid)`
    display: grid;
    grid-template-columns:
        [wrap-start bulk] 24px
        [name] minmax(0, 2fr)
        [editable1] minmax(0, 1fr)
        [editable2] minmax(0, 1fr)
        [actions] 40px [wrap-end];
    column-gap: 24px;

    &.slim {
        grid-template-columns: unset;
    }

    &:empty { display: none; }

    ${fromDesktop`
        margin-inline-start: -48px;
        width: calc(100% + 48px);

        &.slim {
            margin-inline-start: 0;
            width: 100%;
        }
    `}

    ${belowTablet`
        column-gap: 16px;
    `}
`

export const Header = styled(Grid)`
    grid-template-columns: subgrid;
    grid-column: wrap;
    column-gap: inherit;

    ${belowPhone`
        display: none;
    `}
`

const gridColumnHeaderCss = css`
    align-items: center;
    display: flex;
    height: 72px;
    padding: 24px 0;

    ${belowTablet`
        padding: 16px 0;
    `}
`

export const GridColumnHeaderBulk = styled(GridColumnHeaderBase)`
    ${gridColumnHeaderCss}
    grid-area: 1 / bulk;

    & label {
        opacity: calc(1 / 3);
        scale: .75;
        transform-origin: center;
        transition: all .2s ease-in-out;
    }

    ${Header}:hover & label,
    ${Header} & input:focus-visible + label {
        opacity: calc(2 / 3);
        scale: .875;
    }

    &:hover label,
    & input:focus-visible + label,
    &.selected label {
        opacity: 1 !important;
        scale: 1 !important;
    }
`

export const GridColumnHeader = styled(GridColumnHeaderBase)`
    ${gridColumnHeaderCss}

    grid-column: ${p => p.$cell};
`

export const GridColumnHeaderSortable = styled(GridColumnHeaderSortableBase)`
    ${gridColumnHeaderCss}

    grid-column: ${p => p.$cell};
`

export const GridColumnHeaderName = styled(GridColumnHeaderSortable)`
    grid-area: 1 / name;
`

export const GridColumnActionsHeader = styled(GridColumnHeaderBase)`
    ${gridColumnHeaderCss}
    justify-content: center;

    ${belowTablet`
        display: none;
    `}

    > svg {
        ${svgStroke()}
    }
`

export const SkeletonListRow = styled(SkeletonListRowBase)`
    display: grid;
    grid-template-columns: subgrid;
    grid-column: name / wrap;
    align-items: center;
    column-gap: 24px;

    padding-block: 16px;
    min-height: 72px;

    ${belowDesktop`
        grid-column: wrap;
    `}
`

export const SkeletonCell = styled(SkeletonCellBase)`
    grid-column: ${p => p.$cell};

    ${({ $cell }) => $cell === 'name' && belowPhone`
        grid-column: name / editable;
    `}
`

export const LoadingContainer = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 96px;
`

export const TutorialWrapper = styled.div`
    grid-column: wrap;
`

export const Tutorial = styled(TutorialBase)`
    ${fromPhone`
        margin-top: 64px;
    `}
`

export const Empty = styled(EmptyBase)`
    grid-column: wrap;
`